// Common
import { ReactElement, useCallback, useState, useEffect } from 'react'

// Styles
import { makeStyles } from '@material-ui/styles'

// Icons
import PointIconActive from '../../../svg-icons/point-active'
import PointIcon from '../../../svg-icons/point'

// Components
import Col from 'shared-components/col'
import Typography from 'shared-components/typography'
import Row from 'shared-components/row'
import QuizBody from '../body'
import { Button } from '@material-ui/core'
import Slider from '../../../../shared-components/slider'
import Info from 'components/forms/info'
import Location from 'components/forms/location'
import Buttons from 'components/common/Buttons'

// Hooks
import useMobile from '../../../hooks/useMobile'

// Interface
import { IPropsContext, Answers } from '../../../interface'

const useStyle = makeStyles({
	button: {
		textAlign: 'center',
		width: '100%',
		marginRight: 20,
		marginBottom: 20,
		color: '#8A54E8',
		border: '2px solid #8A54E8',
		backgroundColor: '#fff',
		textTransform: 'none',
		transition: 'none',
		'&:hover': {
			color: '#fff',
			border: 'none',
			backgroundColor: '#8A54E8',
			transition: 'none',
		},
	},
	active: {
		color: '#fff',
		border: '1px solid #8A54E8',
		backgroundColor: '#8A54E8',
		marginRight: 20,
		marginBottom: 20,
		textTransform: 'none',
		width: '100%',
		transition: 'none',
		'&:hover': {
			color: '#fff',
			border: 'none',
			backgroundColor: '#8A54E8',
			transition: 'none',
		},
	},
})

export default function QuizContext(props: IPropsContext): ReactElement{
	const [value, setValue] = useState<number>(0)
	const [qa, setQa] = useState<Answers[]>([])
	const [active, setActive] = useState<any>(0)
	const classes = useStyle()
	const { questions, onClickNext, question, goBack, id, number } = props
	const options = question && question.answerOptions || []
	const current = question && question.step

	useEffect(() => {
		if (id === question.id){
			const a = sessionStorage.getItem(question.id) || ''
			setValue(question.type === 'slider' ? parseInt(options[0]) : options[0])
			setActive(question.type === 'slider' ? parseInt(a) : a)
		}
	}, [question.id])

	useEffect(() => {
		sessionStorage.setItem('qa', JSON.stringify(qa))
	}, [qa])

	const handleAnswer = useCallback((event, value) => {
		setValue(value)
		const id = question.id
		sessionStorage.setItem(id, value)
		setActive(value)
		setQa((prevState: Answers[]) => ([...prevState, {question: id, answer: value}]))
		sessionStorage.setItem('qa', JSON.stringify(qa))
	}, [question, value, qa])

	const changeContext = useCallback(() => {
		switch(question.type){
		case 'location':
			return <Location goBack={goBack} />
		case 'info':
			return <Info goBack={goBack} onClickNext={onClickNext} answers={questions} id={id} />
		default:
			return ''
		}
	}, [question.type])

	const sliderValue = isNaN(active) ? value : active
	const mobile = useMobile()

	return (
		<>
			<Col
				align='center'
				justify='center'
			>
				<Row style={{margin: '6px 0px'}}>
					<>
						{questions.map((question, index) =>
							<div key={question.id}>
								{ question.step === current ?
									<PointIconActive /> :
									index < number ?
										<PointIcon done={'done'}/> :
										<PointIcon done={'empty'}/>
								}
							</div>,
						)}
					</>
				</Row>
				<Typography
					fontWeight='600'
					style={ mobile ? {
						marginBottom: '15px',
						padding: '0 20px',
						textAlign: 'center',
					}:{
						marginBottom: '46px',
						padding: '0 20px',
						textAlign: 'center',
					}}
				>
					{question.name}
				</Typography>
				<>
					<QuizBody>
						<>
							{question.type === 'slider' ?
								<Slider
									min={parseInt(options[0])}
									defaultValue={parseInt(options[1])}
									value={sliderValue}
									max={parseInt(options[2])}
									variant={options[3]}
									onChange={handleAnswer}
								/>
								:
								options.map((option: string) =>
									<Button
										style={{height: '50px'}}
										onClick={event => handleAnswer(event, option)}
										className={active === option ? classes.active : classes.button}
										key={option}
									>
										{option}
									</Button>,
								)
							}
						</>
					</QuizBody>
					{(question.type === 'slider' || question.type === 'options') &&
						<Buttons
							goBack={goBack}
							goNext={onClickNext}
							disable={false}
						/>
					}
					{(question.type !== 'slider' || question.type !== 'options') && changeContext()}
				</>
			</Col>
		</>
	)
}
